import type { FaireProductEntity } from "../../entity_types/product";

export const p_e5tq8j5b34: FaireProductEntity = {
  token: "p_e5tq8j5b34",
  type: "product",
  name: "JLS3504-Soft Lightweight Loose Fit Textured Pullover Sweater",
  brandToken: "b_asqn94k6h7",
  brandName: "La Miel",
  imageUrl:
    "https://cdn.faire.com/fastly/ac0321f16213e8b8540697aeefc305923826dc8447100507e522dc8edab9d37e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b7b55652b3012bcc6edd931829298979090c14312ef3fc544b384ffed7ecb64.jpeg",
    "https://cdn.faire.com/fastly/1f2aaf1b8b69928f1a0d03c0781ac631f9a61057b6f6008c9f2bde65aa33e722.jpeg",
    "https://cdn.faire.com/fastly/225d45808a359617383898d19c02d1fe8f7560df5bac8ad1361df51716b81328.jpeg",
    "https://cdn.faire.com/fastly/4c9624e8f23ee7f635299e75d8c698580aaae272b467c85291a529d450d35f90.jpeg",
    "https://cdn.faire.com/fastly/d43863f9c68dc58bf04039376f54f7133575213a2a710906cf8751f0d31187b0.jpeg",
    "https://cdn.faire.com/fastly/4fe127b588784af4b82563efdb8b86f634fae9bbf37011932a51c4db35ff6dc3.jpeg",
    "https://cdn.faire.com/fastly/19836129fac2abfbc3d427640d3f176033e7e78a99f3c65185542823f557131b.jpeg",
    "https://cdn.faire.com/fastly/acd973cdfdb37bf4eae3f0860dd7042d69b76e29dd0474ad7d5e91caa146824a.jpeg",
    "https://cdn.faire.com/fastly/0d87f35baff36fe87808db95f48a62fa3f65dc704520b7200c887f71dbe5e6a0.jpeg",
    "https://cdn.faire.com/fastly/c1ecf233c896ab27255e696f2e7e096b69aaf73e4b5a0904f3510c8e4436a885.jpeg",
    "https://cdn.faire.com/fastly/1748234a4d8fa87746be0dc896acbd4cad82b46934d48512870a5e8f11ce46db.jpeg",
    "https://cdn.faire.com/fastly/5bb1cc57c43cb97183179d0a1822e437e565993a8cca484e3a1c0552534b3fdf.jpeg",
    "https://cdn.faire.com/fastly/92fa7a9722e8ec470a07219e80249d65b553dd39a77fcd946d1617bfc14d8283.jpeg",
    "https://cdn.faire.com/fastly/650ad6b26081e0ca1992bd226a699d8c74588be1abcb32fe8bca89080a4c0356.jpeg",
    "https://cdn.faire.com/fastly/e7e3cf2e59285cc35bcbd74cc09e20871b3ee5e8d51a142a308acfe9ec2c85e8.jpeg",
    "https://cdn.faire.com/fastly/7e98c8ab085262fccfd75b04d5db520723ad15410697df9ab3d9031e52197234.jpeg",
    "https://cdn.faire.com/fastly/671e3a5c6b54d8a79ceed23898e7ba2670728a9a2a263147d46261b0c2d441ed.jpeg",
    "https://cdn.faire.com/fastly/a3390bcba2d0940dbb003fe38278d2b377d06318594a65ba74dee25a9e58f774.jpeg",
    "https://cdn.faire.com/fastly/736be17bc31de458035dd4be927ac68e8aeec4f592bf3908d12e67b461b970a6.jpeg",
    "https://cdn.faire.com/fastly/25e072e8ad023092e868e3b803e9ef6b0584349057866bee1b8dcfd1841da4bd.jpeg",
    "https://cdn.faire.com/fastly/6ccdb1bb1f13fc28e5565b47008aa4068f2b8ffb4059adeba04a77203a18d4df.jpeg",
    "https://cdn.faire.com/fastly/7ea8943d7752e99d411305b83ca9da6808fe5bc044db9a0239ae906bf8af4be7.jpeg",
    "https://cdn.faire.com/fastly/c5b4cd1798ccc38582df0f87d0542dde118bb540f7be9150f26a40b84f1b6cdc.jpeg",
    "https://cdn.faire.com/fastly/bbde507de1b255110e852c0fe56adab597b667fb44509c54ae868a50ed38a705.jpeg",
    "https://cdn.faire.com/fastly/0e0af55d5802763396bb83882905c04ba64a5d187394b5c5bcc09328ef9accf2.jpeg",
    "https://cdn.faire.com/fastly/cbf1c66402bff8fa4da1f3e2594b0309e26829407d11a6b0ee15bc0721fd50f1.jpeg",
    "https://cdn.faire.com/fastly/165ca62a87d88c03f01465ab523e0d8e74ab339fb96da7cfdb4d06cc45866cbb.jpeg",
    "https://cdn.faire.com/fastly/2ca137818e8e39196c421be60f6583ed6e08e6f8071b03fae05caeefc8012b30.jpeg",
    "https://cdn.faire.com/fastly/38aaf2f0275978f40bcd8bc5e5f6fcd7254136ab99782d4860f77a6bd0ce62e3.jpeg",
    "https://cdn.faire.com/fastly/41a9908a9925a36e0fe8733b0e43568e1109498acfb256108d8c57ba79e2ef87.jpeg",
    "https://cdn.faire.com/fastly/1ce55518e638e7adf7f20a59f73ded3053676ff398b084a00e10cf768955f89c.jpeg",
    "https://cdn.faire.com/fastly/94dd0139a9e823fac2d4c8128dea98c9ba67caba3c7869797ae3d6d3d1b6dca5.jpeg",
    "https://cdn.faire.com/fastly/7a4b9e7462a534f23b8dcd64bebcf344384911c199026a4da72a30f34d71f047.jpeg",
  ],
  priceDollars: 101.7,
  description:
    "Unbelievably soft, lightweight easy to wear sweater featured in relaxed fit, stretchy fabric, high low hemline, side slit detail. Wear this relaxed fit sweater as many ways as you can think of as a sweater and a perfect layering piece. Made to be worn from season to season, this pullover sweater can be layered up or down.\n\nsoft sweater top, lightweight sweater, pullover, loose fit, layering piece, textured fabric, side slit, wide v-neck, stretchy fabric, fall, sweater for women",
  tags: [],
  msrpDollars: 203.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:41.537Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
